import { daysOrder } from "./constants";

export function expandRange(range: string | string[]): string[] {
  // If already an array, just return valid days from it
  if (Array.isArray(range)) {
    return range.filter(day => daysOrder.includes(day));
  }

  if (typeof range !== "string" || !range.trim()) return [];

  // If comma-separated (like "Tuesday, Friday")
  if (range.includes(",")) {
    return range
      .split(",")
      .map(day => day.trim())
      .filter(day => daysOrder.includes(day));
  }

  // Otherwise, assume dash-separated (like "Tuesday-Friday")
  const [start, end] = range.split("-").map(day => day.trim());
  const startIdx = daysOrder.indexOf(start);
  const endIdx = daysOrder.indexOf(end);

  if (startIdx === -1 || endIdx === -1) return [];

  // Handle wrap-around (e.g., Friday-Monday)
  if (endIdx < startIdx) {
    return [...daysOrder.slice(startIdx), ...daysOrder.slice(0, endIdx + 1)];
  }

  return daysOrder.slice(startIdx, endIdx + 1);
}
